module.exports = __webpack_public_path__ + "img/fab-instagram-square.245e40c9.svg";